export function ourProgramSlider() {
    let $programSlider = $(".our-program-list");
    let $win = $(window);

    let initSliders = function () {
        $programSlider.each(function () {
            let $slider = $(this);

            if (!$slider.hasClass("slick-initialized")) {
                $slider.slick({
                    slidesToShow: 1.22,
                    slidesToScroll: 1,
                    dots: false,
                    arrows: false,
                    infinite: false,
                    mobileFirst: true,
                    focusOnSelect: true,
                    responsive: [
                        {
                            breakpoint: 568,
                            settings: {
                                slidesToShow: 1.5,
                            }
                        },
                        {
                            breakpoint: 744,
                            settings: {
                                slidesToShow: 2.2,
                            }
                        },
                        {
                            breakpoint: 1200,
                            settings: "unslick",
                        },
                    ]
                });
            }
        });
    };

    if ($win.width() < 1200) {
        if ($programSlider.offset().top - $win.scrollTop() < 400 && !$programSlider.hasClass("slick-initialized")) {
            initSliders();
        }
    }

    $win.on("resize, scroll", function () {
        if ($win.width() < 1200) {
            if ($programSlider.offset().top - $win.scrollTop() < 400 && !$programSlider.hasClass("slick-initialized")) {
                initSliders();
            }
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/ourProgramSlider.js